import { faCog, faCopy, faTimes } from '@fortawesome/pro-light-svg-icons';
import TwinIcon, { TwinIconProp } from '../../../../../../../../../../baseComponents/TwinIcon';
import { PdfConfigTemplateSingleTy } from '../../../../types';
import { useCallback } from 'react';
import { arrayMove } from '@dnd-kit/sortable';
import ConfigPdfTemplateChangePosIcons from '../../../ConfigPdfTemplateChangePosIcons';
import { nanoid } from 'nanoid'

interface CPTListingElementProps {
    onEdit: () => void
    onDelete: () => void
    icon: TwinIconProp;
    text: string;
    elementKey: string
    setConfig: React.Dispatch<React.SetStateAction<PdfConfigTemplateSingleTy>>
}

const CPTListingElement: React.FC<CPTListingElementProps> = ({ onEdit, onDelete, icon, text, elementKey, setConfig }) => {
    const { handleChangePositionDown, handleChangePositionUp, handleDuplicate } = useCPTListingElementLogic({elementKey, setConfig})
    return (
        <div className='cpt_listing_element flex items-center regular16' >
            <TwinIcon icon={icon} />
            <span className='twin_elipsis configPdf_tab_element_element'>{text}</span>
            <TwinIcon icon={faTimes} className='ml-auto cursor-pointer' onClick={onDelete} />
            <TwinIcon icon={faCog} className='ml-5 p-3 cursor-pointer' onClick={onEdit} />
            <ConfigPdfTemplateChangePosIcons handleChangePositionDown={handleChangePositionDown} handleChangePositionUp={handleChangePositionUp} />
            <TwinIcon icon={faCopy} className='ml-5 p-3 cursor-pointer' onClick={handleDuplicate} />
        </div>
    )
}
interface CPTListingElementLogicProps {
    elementKey: string
    setConfig: React.Dispatch<React.SetStateAction<PdfConfigTemplateSingleTy>>
}

const useCPTListingElementLogic = ({ setConfig, elementKey }: CPTListingElementLogicProps) => {
    const handleChangePositionUp = useCallback(() => {
        setConfig((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            const myPositions = elementKey.split(',')
            const pagePosition = parseInt(myPositions[0])
            const sectionPosition = parseInt(myPositions[1])
            const elementPosition = parseInt(myPositions[2])
            const toIndex = elementPosition - 1 < 0 ? elementPosition : elementPosition - 1
            const newElements = arrayMove(copy.pages[pagePosition].sections[sectionPosition].elements, elementPosition, toIndex)
            copy.pages[pagePosition].sections[sectionPosition].elements = newElements
            return { ...copy }
        })
    }, [setConfig, elementKey])

    const handleChangePositionDown = useCallback(() => {
        setConfig((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            const myPositions = elementKey.split(',')
            const pagePosition = parseInt(myPositions[0])
            const sectionPosition = parseInt(myPositions[1])
            const elementPosition = parseInt(myPositions[2])
            const lastPosition = copy.pages[pagePosition].sections[sectionPosition].elements.length - 1
            const toIndex = elementPosition + 1 > lastPosition ? elementPosition : elementPosition + 1
            const newElements = arrayMove(copy.pages[pagePosition].sections[sectionPosition].elements, elementPosition, toIndex)
            copy.pages[pagePosition].sections[sectionPosition].elements = newElements
            return { ...copy }
        })
    }, [setConfig, elementKey])

    const handleDuplicate = useCallback(() => {
        setConfig((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            const myPositions = elementKey.split(',')
            const pagePosition = parseInt(myPositions[0])
            const sectionPosition = parseInt(myPositions[1])
            const elementPosition = parseInt(myPositions[2])
            const myElement = copy.pages[pagePosition]?.sections?.[sectionPosition]?.elements?.[elementPosition]
            copy.pages[pagePosition].sections[sectionPosition].elements.splice(elementPosition, 0, { ...myElement, id: String(elementPosition + 1) + nanoid() })
            return { ...copy }
        })
    }, [setConfig, elementKey])

    return { handleChangePositionUp, handleChangePositionDown, handleDuplicate }
}


export default CPTListingElement